import BaseErrorHandler from '@/apis/errorHandler/handler/BaseErrorHandler'
import  AlertTypeEnum from '@/apis/errorHandler/AlertTypeEnum'
import router from "@/router";

export default class ValidationException extends BaseErrorHandler {
    protected AlertType: AlertTypeEnum = AlertTypeEnum.ERROR;
    protected Code: string = "Common.ValidationException";

    constructor(messageKey?: string, message?: { [key: string]: Array<string> }) {
        let errorMessage = "";
        let index = 0;
        for (let n in message) {
            index++
            errorMessage += index + ":" + n + ": " + message[n].join(", ") + "</br>";
        }
        super(messageKey, errorMessage);
    }

    customizeAction(): void {

    }
}
